import React from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import { diff } from "deep-diff";
import { mutate } from "swr";
import { toast } from "react-toastify";

import {
    store,
    setIsModalOpenedSimpleProject,
    setIsModalConfirmationConfigurationKiosk,
    setKioskProject,
} from "../../../store/project";
import {
    computedStore,
    generalConfigStore,
    setChosenTemplate,
    setInitItemsFromGeneralSetting,
    setIsInformationModesEmpty,
    setIsModalOpened,
    setIsProjectModesModalOpened,
    setProject,
} from "../../../store";
import { setKey } from "@pages/Project/store";

import { store as userStore } from "../../../components/VerticalLayout/store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";

import "./index.css";
import { moveArrayElementToTheBegin } from "../../../helpers/general";
import { useFetchGlobal } from "../../../api/hooks";

type PropsType = {
    children: React.ReactNode;
    title: string;
    rowData: any;
    setIsDataUpdated: Function;
    isDataUpdated: boolean | number;
    setIsCreatedProject: Function;
};

export function ModalWrapperSimple({
    children,
    title = "",
    rowData,
    setIsDataUpdated,
    isDataUpdated,
    setIsCreatedProject,
}: PropsType): JSX.Element {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const { isModalOpenedSimpleProject } = useSnapshot(store);

    const navigate = useNavigate();

    const toggle = () => {
        setIsModalOpenedSimpleProject(!isModalOpenedSimpleProject);
        setIsCreatedProject(false);
    };
    const {
        userID,
        franchiseID,
        projectId,
        shopID,
        oneShop,
        operatorID,
    } = useSnapshot(userStore);

    const [isDataChanged, setIsDataChanged] = React.useState<boolean>(false);
    const { items } = useSnapshot(computedStore);
    const {
        isWaysTabActive,
        project: { template, files },
    } = useSnapshot(generalConfigStore);
    React.useEffect(() => {
        if (isDataChanged === true) {
            if (
                (oneShop &&
                    (rowData === undefined ||
                        Object.keys(rowData).length === 0)) ||
                (oneShop &&
                    rowData !== undefined &&
                    rowData?.template?.id === "")
            ) {
                handleUpdateProjectShopsButtonOnClickEvent();
                handleSaveTemplateFromShopsToFranchiseOnClickEvent();
            } else if (
                oneShop &&
                rowData !== undefined &&
                rowData?.template.id !== ""
            ) {
                handleUpdateProjectShopsButtonOnClickEvent();
            } else {
                handleUpdateProjectButtonOnClickEvent(template, files);
            }
            setIsProjectModesModalOpened(false);
            setIsCreatedProject(false);
            setIsModalOpened(false);
        }

        // eslint-disable-next-line
    }, [isDataChanged, template, files]);

    async function handleUpdateProjectButtonOnClickEvent(
        template: any,
        files: any
    ) {
        let apiUrl: any;
        apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/project/template`;
        try {
            const result: any = await fetchGlobal(apiUrl, {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    userId: userID,
                    franchiseId: franchiseID,
                    project_id: "PROJECT",
                    projectId: projectId,
                    shopId: "0",
                    operatorId: operatorID,
                    data: {
                        template: template,
                        files: files,
                    },
                }),

                method: "POST",
            });
            if (result.error) {
                throw Error(result.message);
            }
            mutate(apiUrl, result);
            setIsModalOpenedSimpleProject(!isModalOpenedSimpleProject);
            if (!oneShop) {
                toast.success(`${t("Template saved successfully")}`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    icon: <CheckboxIcon height={25} width={25} fill="white" />,
                });

                let willUpdate = true;
                if (
                    rowData !== undefined &&
                    Object.keys(rowData).length !== 0 &&
                    rowData?.subRows.length > 0 &&
                    (diff(template, generalConfigStore.project.template) !==
                        undefined ||
                        diff(
                            rowData.files,
                            generalConfigStore.project.files
                        ) !== undefined)
                ) {
                    rowData?.subRows.forEach((elt: any) => {
                        if (
                            elt.template !== "" ||
                            (elt.subRows &&
                                elt.subRows.some(
                                    (el: any) => el.template !== ""
                                ))
                        ) {
                            willUpdate = false;
                            setIsModalConfirmationConfigurationKiosk(true);
                        }
                    });
                }
                if (willUpdate === true)
                    setKey(Math.floor(Math.random() * 10000));
            } else {
                setKey(Math.floor(Math.random() * 10000));
            }
        } catch (error) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }
    async function handleUpdateProjectShopsButtonOnClickEvent() {
        let apiUrl: any;
        const kioskTemplate = generalConfigStore.project;
        setKioskProject(kioskTemplate);
        apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/project/template`;
        try {
            const result: any = await fetchGlobal(apiUrl, {
                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify({
                    userId: userID,
                    franchiseId: franchiseID,
                    project_id: "PROJECT",
                    projectId: projectId,
                    shopId: shopID,
                    operatorId: operatorID,
                    data: {
                        template: generalConfigStore.project.template,
                        files: generalConfigStore.project.files,
                    },
                }),

                method: "POST",
            });
            if (result.error) {
                throw Error(result.message);
            }
            mutate(apiUrl, result);
            toast.success(`${t("Template saved successfully")}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                icon: <CheckboxIcon height={25} width={25} fill="white" />,
            });

            if (
                rowData !== undefined &&
                Object.keys(rowData).length > 0 &&
                rowData?.template.id !== "" &&
                (diff(kioskTemplate, generalConfigStore.project.template) !==
                    undefined ||
                    diff(rowData.files, generalConfigStore.project.files) !==
                        undefined)
            ) {
                rowData?.subRows.forEach((elt: any) => {
                    if (elt.template !== "") {
                        setIsModalConfirmationConfigurationKiosk(true);
                    }
                });
            } else {
                setKey(Math.floor(Math.random() * 10000));
            }
        } catch (error) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }

    const handleSaveTemplateFromShopsToFranchiseOnClickEvent = async () => {
        try {
            const shopId = "0";
            const apiBase = process.env.REACT_APP_API_V2_URL;
            const kioskProject = generalConfigStore.project;

            const [
                languages,
                saleMethods,
                reglements,
                informationModes,
                logo,
            ] = (await Promise.all([
                fetchGlobal(
                    `${apiBase}/settings/consomation/langue?franchiseId=${franchiseID}&shopId=${shopId}`
                ),
                fetchGlobal(
                    `${apiBase}/settings/consomation/sale?franchiseId=${franchiseID}&shopId=${shopId}`
                ),
                fetchGlobal(
                    `${apiBase}/settings/consomation/reglement?franchiseId=${franchiseID}&shopId=${shopId}`
                ),
                fetchGlobal(
                    `${apiBase}/settings/consomation/information?franchiseId=${franchiseID}&shopId=${shopId}`
                ),
                fetchGlobal(
                    `${apiBase}/settings/consomation/logo?franchiseId=${franchiseID}&shopId=${shopId}`
                ),
            ])) as [any, any, any, any, any];

            const hasActiveSaleMethod = saleMethods.some(
                (item: any) =>
                    item.active &&
                    item.id !== "f25e7c96-b5d3-4f2e-acd0-1500258283c2"
            );

            const hasActiveLanguage = languages.some(
                (item: LanguagesItemType) => item.active
            );

            if (!hasActiveSaleMethod || !hasActiveLanguage) {
                toast.warning(
                    t(
                        "Please note that the assignment could not be made to one or more stores. Please check the store(s) data settings."
                    ),
                    {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                        theme: "colored",
                        icon: (
                            <CheckboxIcon height={25} width={25} fill="white" />
                        ),
                    }
                );
                return;
            }

            const hasInformationModes =
                informationModes.length > 0 &&
                informationModes.some((info: ProjectMainContentItemType) =>
                    saleMethods.some(
                        (sale: any) =>
                            sale.active &&
                            Object.keys(info.active).includes(sale.name)
                    )
                );

            setIsInformationModesEmpty(!hasInformationModes);

            const orderedLanguages =
                languages.filter(
                    (l: LanguagesItemType) => l.active && !l.isDefault
                ).length > 1
                    ? moveArrayElementToTheBegin(
                          languages.find((l: LanguagesItemType) => l.isDefault),
                          moveArrayElementToTheBegin(
                              languages.find(
                                  (l: LanguagesItemType) =>
                                      l.active && !l.isDefault
                              ),
                              languages
                          )
                      )
                    : languages;

            const template = {
                ...kioskProject.template,
                content: {
                    ...kioskProject.template.content,
                    languages: { items: orderedLanguages },
                    salesMethods: { items: saleMethods },
                    meansOfPayment: { items: reglements },
                    informationModes: { items: informationModes },
                    generalDesign: {
                        ...kioskProject.template.content.generalDesign,
                        logo,
                    },
                },
            };

            const updatedProject = {
                ...kioskProject,
                template,
            };

            setProject(updatedProject);
            setInitItemsFromGeneralSetting({
                informationModes,
                saleMethods,
                reglements,
                languages,
                logo,
            });
            setChosenTemplate(template, kioskProject.files);

            const apiUrl = `${apiBase}/settings/project/template`;

            const result: any = await fetchGlobal(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    userId: userID,
                    franchiseId: franchiseID,
                    projectId,
                    project_id: "PROJECT",
                    shopId,
                    operatorId: operatorID,
                    data: {
                        template,
                        files: kioskProject.files,
                    },
                }),
            });

            mutate(apiUrl, result);

            if (result?.error) {
                throw new Error(result.message);
            }

            setKey(Math.floor(Math.random() * 10000));
        } catch (error) {
            console.error(error);
            toast.error(t("There's an error"), {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
            });
        }
    };

    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                toggle={toggle}
                isOpen={isModalOpenedSimpleProject}
                className="modal-wrapper__clz"
            >
                <ModalHeader toggle={toggle} className="text-uppercase">
                    {title}
                </ModalHeader>
                <ModalBody className="p-0">{children}</ModalBody>
                <ModalFooter>
                    {isWaysTabActive ? (
                        <CustomMainColorButton
                            outline={true}
                            rounded={true}
                            className="m-2"
                            variant="primary"
                            disabled={Object.values(items.ways).length === 0}
                            onClick={() => navigate("/fullscreen-preview")}
                        >
                            {t("See")}
                        </CustomMainColorButton>
                    ) : null}
                    <CustomMainColorButton
                        disabled={
                            generalConfigStore.project.template.id === ""
                                ? true
                                : false
                        }
                        className="w-20"
                        rounded
                        variant="primary"
                        onClick={() => {
                            setIsDataChanged(true);
                        }}
                    >
                        {t("Save")}
                    </CustomMainColorButton>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
